var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.762,
    height: 62.888,
    viewBox: "0 0 100.762 62.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 100.762,
    height: 62.888
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M12.912,41.073a1.958,1.958,0,1,0,1.947,1.958,1.953,1.953,0,0,0-1.947-1.958",
    transform: "translate(4.683 17.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M30.65,39.663A2.971,2.971,0,1,0,33.6,42.634a2.961,2.961,0,0,0-2.953-2.971",
    transform: "translate(11.83 17.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M36.582,41.221,18.031,37.482a2.94,2.94,0,0,0-1.115-.01l-7.43,2.943A1.629,1.629,0,0,0,8.462,41.93v.421a2.711,2.711,0,0,0,2.7,2.719h.541a2.32,2.32,0,1,1,4.594-.447,2.428,2.428,0,0,1-.043.447h19.65a3.322,3.322,0,0,1,.675-3.849M18.118,40.042a.768.768,0,1,1,.764-.768.767.767,0,0,1-.764.768",
    transform: "translate(3.614 16.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M9.617,39.525l.071.179a.3.3,0,0,0,.4.172l4.083-1.637a.31.31,0,0,0,.173-.4l-.071-.179a.757.757,0,0,0-.986-.426l-3.245,1.3a.766.766,0,0,0-.424.994",
    transform: "translate(4.085 16.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M11.5,42.97l1.544,3.9a.213.213,0,0,0,.278.119l2.51-1.005a.216.216,0,0,0,.12-.28L14.4,41.8a1.01,1.01,0,0,0-1.045-.635L4.041,17.086a.276.276,0,0,0-.357-.158L2.6,17.353a.278.278,0,0,0-.156.359l9.331,24.114A1.018,1.018,0,0,0,11.5,42.97",
    transform: "translate(1.036 7.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M5.072,18.088,2.687,11.934a.6.6,0,0,0-.781-.345l-1.523.6a.609.609,0,0,0-.343.785l2.385,6.154a.6.6,0,0,0,.781.345l1.523-.6a.611.611,0,0,0,.343-.785",
    transform: "translate(0 5.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M56.609,37.718l-.019,6.006a2.569,2.569,0,0,0,2.289,2.787l6.321.078a2.571,2.571,0,0,0,2.356-2.732l.066-6.45a3.236,3.236,0,0,1-2.476.685c-3.04,0-5.553-.125-8.537-.373",
    transform: "translate(24.171 16.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M88.38,21.657l-3.212.066a4.407,4.407,0,0,0-3.305,1.6l-1.109-2.587.031,2.956,1.821,3.989a1.082,1.082,0,0,1-.05.994,1.071,1.071,0,0,1-.838.525l-9.383.725A111.128,111.128,0,0,1,56.21,30,111.091,111.091,0,0,1,40.095,27.7l-8.961-1.954a1.068,1.068,0,0,1-.758-.635,1.08,1.08,0,0,1,.084-.989l2.34-3.707.509-3.489-1.774,2.961a4.416,4.416,0,0,0-3.061-2.034l-3.172-.5a3.009,3.009,0,0,0-.929,5.946l4.774.755a17.336,17.336,0,0,0-1.6,6.181l-.568,8.422a3.266,3.266,0,0,0,2.87,3.473c8.016.932,16.395,1.721,25.116,2.32l.186.013c8.79.6,17.262.959,25.389,1.127a3.261,3.261,0,0,0,3.309-3.052l.568-8.422a17.351,17.351,0,0,0-.751-6.342l4.832-.1a3.009,3.009,0,0,0-.123-6.017M43.1,34.569a3.626,3.626,0,0,1-.114.548l0,.013a1.529,1.529,0,0,1-1.209,1.08c-.024,0-.05.007-.074.01a18.071,18.071,0,0,1-3.82.056,18.429,18.429,0,0,1-1.941-.287,7.963,7.963,0,0,1-3.278-1.506,2.206,2.206,0,0,1-.846-1.889l.163-2.372a1.09,1.09,0,0,1,.9-1,1,1,0,0,1,.147-.014l1.908-.067a3.522,3.522,0,0,1,2.058.579c.351.231.754.494,1.2.78,1.276.821,1.784,1.12,2.723,1.747.428.286,1.01.682,1.7,1.18a1.217,1.217,0,0,1,.492,1.147m21.992,6.936-.08,1.193a1.072,1.072,0,0,1-1.14,1l-17-1.16a1.073,1.073,0,0,1-.995-1.146l.08-1.193a1.074,1.074,0,0,1,1.14-1l17,1.16a1.075,1.075,0,0,1,.995,1.147m15.788-7.947-.158,2.372a2.192,2.192,0,0,1-1.092,1.757,7.923,7.923,0,0,1-3.451,1.047,17.927,17.927,0,0,1-5.738-.551l-.073-.022a1.531,1.531,0,0,1-1.052-1.235l0-.013a3.716,3.716,0,0,1-.039-.559,1.216,1.216,0,0,1,.642-1.07c.751-.4,1.38-.714,1.842-.939,1.015-.494,1.558-.721,2.931-1.361.478-.223.912-.428,1.29-.609a3.52,3.52,0,0,1,2.118-.294l1.881.326a.941.941,0,0,1,.143.034,1.092,1.092,0,0,1,.758,1.116",
    transform: "translate(9.331 7.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M55.743,28.2c.137.019.275.036.412.056l2.963.426,17.551,2.528-.223-21.33c-.037-3.558-2.081-6.54-4.915-7.169L69.609,2.29A96.152,96.152,0,0,0,40.837.326L38.875.488C35.982.726,33.557,3.4,33.042,6.923l-3.084,21.1L51.2,27.887c.611.006,3.937.283,4.547.317",
    transform: "translate(12.796 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M56.8,20.243c-.061-.009-2.619-.276-2.684-.284-.676-.046-3.252-.066-3.929-.075l-19.907.136-2,3.166a.419.419,0,0,0,.263.635l8.959,1.953a110.514,110.514,0,0,0,32.052,2.21l9.385-.724a.422.422,0,0,0,.347-.593l-1.557-3.409-19.6-2.823Z",
    transform: "translate(12.054 8.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M24.1,39.8l9.456-2.32a2.578,2.578,0,0,0,.989-.58l.995-.935-2.68-.144L18.567,38.76Z",
    transform: "translate(7.93 15.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    d: "M.245,0h.6a.246.246,0,0,1,.246.246v4.61A.245.245,0,0,1,.841,5.1h-.6A.246.246,0,0,1,0,4.856V.245A.245.245,0,0,1,.245,0Z",
    transform: "translate(39.801 51.119) rotate(-85.7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon_car.830b628d2751fd18266ab035abca4c57.svg";
export { ForwardRef as ReactComponent };